import React from 'react';
import { FormattedMessage } from 'react-intl';
import Proptypes from 'prop-types';
import { SaleEventFooterVariant } from '../../../../_shared/types/trade';

import { StyledBox, StyledEnd, StyledJumpToStart } from './Styles';

const propTypes = {
  testId: Proptypes.string.isRequired,
  className: Proptypes.string.isRequired,
  variant: Proptypes.oneOf([
    SaleEventFooterVariant.COMPLETE,
    SaleEventFooterVariant.CONTINUED
  ]).isRequired,
  onJumpClick: Proptypes.func.isRequired
};

const ListSaleEventFooter = ({ testId, className, variant, onJumpClick }) => (
  <StyledBox testId={testId} className={className} id={className}>
    <StyledEnd>
      {variant === SaleEventFooterVariant.CONTINUED ? (
        <FormattedMessage id="list.saleEvent.event.continued" />
      ) : (
        <FormattedMessage id="list.saleEvent.end.of.event" />
      )}
    </StyledEnd>
    <StyledJumpToStart onClick={onJumpClick}>
      <FormattedMessage id="list.saleEvent.start.of.event" />
    </StyledJumpToStart>
  </StyledBox>
);

ListSaleEventFooter.propTypes = propTypes;

export default ListSaleEventFooter;
